<template>
  <div class="auto-finetune-landing flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        Auto Finetune
      </span>
    </div>

    <div class="auto-finetune-landing__body flex-grow-1 overflow-y-auto px-20 py-3">
      <a-tabs :activeKey="activeTabKey" @change="onTabChange">
        <a-tab-pane key="runOnce" tab="Run Once">
          <AutoFinetuneSchedule mode="once" />
        </a-tab-pane>

        <a-tab-pane key="schedule" tab="Schedule">
          <AutoFinetuneSchedule mode="recurring" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import AutoFinetuneSchedule from './AutoFinetuneSchedule.vue';

export default {
  name: 'AutoFinetuneLanding',
  components: {
    AutoFinetuneSchedule
  },
  data() {
    return {
      activeTabKey: 'runOnce'
    };
  },
  methods: {
    onTabChange(key) {
      this.activeTabKey = key;
    }
  }
};
</script>

<style lang="scss" scoped>
.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}
</style>
